module.exports = __webpack_public_path__ + "static/media/logo.dce07fbc.png";